(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[308],{

/***/ 7455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports PortfolioCategoryTranslation, PortfolioCategory */
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6626);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8288);
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2705);
/* harmony import */ var _xFrame4_business_BusinessEntityWithTranslation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3032);
/* harmony import */ var _xFrame4_business_Constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(298);







var PortfolioCategoryTranslation = /*#__PURE__*/ function(BusinessEntityTranslation) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PortfolioCategoryTranslation, BusinessEntityTranslation);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(PortfolioCategoryTranslation);
    function PortfolioCategoryTranslation() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, PortfolioCategoryTranslation);
        var _this;
        _this = _super.apply(this, arguments);
        _this.subtitle = "";
        _this.slug = "";
        _this.seoTitle = "";
        _this.seoDescription = "";
        _this.seoKeywords = "";
        return _this;
    }
    return PortfolioCategoryTranslation;
}(_xFrame4_business_BusinessEntityWithTranslation__WEBPACK_IMPORTED_MODULE_2__/* .BusinessEntityTranslation */ .Yc);
var PortfolioCategory = /*#__PURE__*/ function(BusinessEntityWithTranslation) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(PortfolioCategory, BusinessEntityWithTranslation);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(PortfolioCategory);
    function PortfolioCategory() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, PortfolioCategory);
        var _this;
        _this = _super.apply(this, arguments);
        _this.createTranslationObject = function() {
            return new PortfolioCategoryTranslation();
        };
        _this.status = _graphql_generated__WEBPACK_IMPORTED_MODULE_1__/* .PortfolioCategoryStatus.Enabled */ .tJ.Enabled;
        return _this;
    }
    var _proto = PortfolioCategory.prototype;
    _proto.getUrl = function getUrl(language) {
        var translation = this.getTranslation(language);
        return _config__WEBPACK_IMPORTED_MODULE_0__/* ["default"].appUrl */ .Z.appUrl + "".concat(language, "/portfolio/").concat(translation === null || translation === void 0 ? void 0 : translation.slug);
    };
    return PortfolioCategory;
}(_xFrame4_business_BusinessEntityWithTranslation__WEBPACK_IMPORTED_MODULE_2__/* .BusinessEntityWithTranslation */ .fA);
PortfolioCategory.manager = new _xFrame4_business_BusinessEntityWithTranslation__WEBPACK_IMPORTED_MODULE_2__/* .EntityWithTranslationManager */ .M4({
    name: "PortfolioCategory",
    createEntity: function() {
        return new PortfolioCategory();
    },
    fields: [
        {
            name: "status",
            isRequiredInput: true
        },
        {
            name: "orderNo"
        },
        {
            name: "thumbnailImage",
            inputProperty: "thumbnailImageFile",
            customGraphQl: _xFrame4_business_Constants__WEBPACK_IMPORTED_MODULE_3__/* .imageInfoGraphQlDetails */ .f5
        },
        {
            name: "itemCount",
            isInput: false
        }
    ],
    translationFields: [
        {
            name: "title",
            isRequiredInput: true
        },
        {
            name: "subtitle"
        },
        {
            name: "slug"
        },
        {
            name: "seoTitle"
        },
        {
            name: "seoDescription"
        },
        {
            name: "seoKeywords"
        }, 
    ],
    graphQlQueryAlias: "portfolioCategories"
});
/* harmony default export */ __webpack_exports__["ZP"] = (PortfolioCategory);


/***/ }),

/***/ 4636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ portfolio_PortfolioCategoryList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./redux/hooks.ts
var hooks = __webpack_require__(6410);
// EXTERNAL MODULE: ./xFrame4/components/next/ALink.tsx
var ALink = __webpack_require__(2768);
// EXTERNAL MODULE: ./xFrame4/components/SmoothImage.tsx
var SmoothImage = __webpack_require__(5423);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/portfolio/PortfolioCategoryThumbnail.tsx





var PortfolioCategoryThumbnail = function(props) {
    var language = (0,hooks/* useAppStateSelector */.k)(function(state) {
        return state.layout.language;
    });
    var translation = props.portfolioCategory.getTranslation(language.code);
    var ref = (0,react.useState)(false), isHover = ref[0], setIsHover = ref[1];
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "portfolio-category-thumbnail col-md-6 col-lg-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "portfolio-category-thumbnail-inner w-100 h-100 cursor-pointer",
            onMouseEnter: function() {
                return setIsHover(true);
            },
            onMouseLeave: function() {
                return setIsHover(false);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SmoothImage/* default */.Z, {
                    src: props.portfolioCategory.thumbnailImage.url,
                    width: props.portfolioCategory.thumbnailImage.width,
                    height: props.portfolioCategory.thumbnailImage.height,
                    createFreshImageUrl: true,
                    className: "w-100 h-100 object-fit-cover"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "portfolio-category-thumbnail-overlay",
                    style: {
                        opacity: isHover ? 1 : 0
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ALink/* default */.Z, {
                        href: props.portfolioCategory.getUrl(language.code),
                        className: "w-100 h-100 d-flex flex-column justify-content-end pb-6 ps-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "portfolio-category-thumbnail-title text-white fw-bold mb-d075",
                                children: translation === null || translation === void 0 ? void 0 : translation.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "portfolio-category-thumbnail-subtitle text-white",
                                children: translation === null || translation === void 0 ? void 0 : translation.subtitle
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var portfolio_PortfolioCategoryThumbnail = (PortfolioCategoryThumbnail);

;// CONCATENATED MODULE: ./components/portfolio/PortfolioCategoryList.tsx


var PortfolioCategoryList = function(props) {
    /** Thumbnails */ var cmpThumbnails = props.portfolioCategories.map(function(portfolioCategory) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(portfolio_PortfolioCategoryThumbnail, {
            portfolioCategory: portfolioCategory
        }, portfolioCategory.id);
    });
    /** Render */ return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "portfolio-category-list row justify-content-start",
        children: cmpThumbnails
    });
};
/* harmony default export */ var portfolio_PortfolioCategoryList = (PortfolioCategoryList);


/***/ }),

/***/ 3032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M4": function() { return /* binding */ EntityWithTranslationManager; },
/* harmony export */   "Yc": function() { return /* binding */ BusinessEntityTranslation; },
/* harmony export */   "fA": function() { return /* binding */ BusinessEntityWithTranslation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6626);
/* harmony import */ var _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7283);
/* harmony import */ var _graphql_apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8969);
/* harmony import */ var _BusinessEntity__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(628);










var BusinessEntityTranslation = function BusinessEntityTranslation() {
    "use strict";
    (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, BusinessEntityTranslation);
};
var BusinessEntityWithTranslation = /*#__PURE__*/ function(BusinessEntity) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(BusinessEntityWithTranslation, BusinessEntity);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(BusinessEntityWithTranslation);
    function BusinessEntityWithTranslation() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, BusinessEntityWithTranslation);
        var _this;
        _this = _super.apply(this, arguments);
        /** The translation objects for each translation language. */ _this.translations = [];
        return _this;
    }
    var _proto = BusinessEntityWithTranslation.prototype;
    /**
     * Get the translation object for a language.
     * 
     * @param language The language code.
     */ _proto.getTranslation = function getTranslation(language) {
        return this.translations.find(function(et) {
            return et.language == language;
        });
    };
    /**
     * Get the value of a translated field.
     * 
     * @param field The field name
     * @param language The translation language.
     * @returns The value of the translated field.
     */ _proto.getField = function getField(field, language) {
        var translation = this.translations.find(function(et) {
            return et.language == language;
        });
        if (translation !== undefined) {
            return translation[field];
        } else {
            return undefined;
        }
    };
    /**
     * Initiate an empty translation for the language. The translation is added to the translations collection.
     * 
     * @param language The language code.
     * @returns The new translation object or an existing one (if translation already exists for the language).
     */ _proto.initTranslation = function initTranslation(language) {
        var translation = this.translations.find(function(et) {
            return et.language == language;
        });
        if (translation === undefined) {
            translation = this.createTranslationObject();
            translation.language = language;
            this.translations.push(translation);
        }
        return translation;
    };
    /**
     * Save the entity translation for a language. Saves the entity too.
     * 
     * @param language The language code.
     * @param translation The translation object.
     */ _proto.saveTranslation = function saveTranslation(language, translation) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var cls;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        // Save the entity first
                        if (_this.id == null && _this.primaryLanguage == null) _this.primaryLanguage = language;
                        _ctx.next = 3;
                        return _this.save();
                    case 3:
                        cls = _this["constructor"];
                        _ctx.next = 6;
                        return cls.manager.saveTranslation(_this, language, translation);
                    case 6:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(BusinessEntityWithTranslation, [
        {
            key: "primaryTranslation",
            get: /** Get the translation object for the primary translation language. */ function get() {
                return this.getTranslation(this.primaryLanguage);
            }
        }
    ]);
    return BusinessEntityWithTranslation;
}(_BusinessEntity__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP);
var EntityWithTranslationManager = /*#__PURE__*/ function(EntityManager) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(EntityWithTranslationManager, EntityManager);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(EntityWithTranslationManager);
    function EntityWithTranslationManager(parameters) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, EntityWithTranslationManager);
        var _this;
        _this = _super.call(this, parameters);
        /** The translated fields. */ _this.translationFields = [];
        // The translation fields (language always exists)
        _this.translationFields = parameters.translationFields.map(function(constructorInput) {
            return new _BusinessEntity__WEBPACK_IMPORTED_MODULE_2__/* .BusinessEntityField */ .Vs(constructorInput);
        });
        _this.translationFields.push(new _BusinessEntity__WEBPACK_IMPORTED_MODULE_2__/* .BusinessEntityField */ .Vs({
            name: "language",
            isRequiredInput: true
        }));
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = _this.translationFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var translationField = _step.value;
                if (translationField.relatedManager == "self") {
                    translationField.relatedManager = (0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_this);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Add primaryLanguage to fields list
        _this.fields.push(new _BusinessEntity__WEBPACK_IMPORTED_MODULE_2__/* .BusinessEntityField */ .Vs({
            name: "primaryLanguage",
            isRequiredInput: true
        }));
        // Add 'translations' to fields list
        _this.fields.push(new _BusinessEntity__WEBPACK_IMPORTED_MODULE_2__/* .BusinessEntityField */ .Vs({
            name: "translations",
            isInput: false,
            customGraphQl: "language " + _this.translationFields.map(function(tf) {
                return tf.name;
            }).join(" ")
        }));
        var _graphQlSaveAlias;
        // Other properties
        _this.graphQlSaveTranslationAlias = (_graphQlSaveAlias = parameters.graphQlSaveAlias) !== null && _graphQlSaveAlias !== void 0 ? _graphQlSaveAlias : "save" + _this.name + "Translation";
        var _graphQlTranslationInputAlias;
        _this.graphQlTranslationInputAlias = (_graphQlTranslationInputAlias = parameters.graphQlTranslationInputAlias) !== null && _graphQlTranslationInputAlias !== void 0 ? _graphQlTranslationInputAlias : _this.name + "TranslationInput";
        return _this;
    }
    var _proto = EntityWithTranslationManager.prototype;
    _proto.saveTranslation = function saveTranslation(entity, language, translation) {
        var _this = this;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var gqlSaveMutation, variables, success, result, graphQlObject;
            return _home_csakiart_app_production_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        gqlSaveMutation = _this.createGraphQlSaveTranslationMutation();
                        variables = {
                            id: entity.id,
                            input: _this.createTranslationInputObject(language, translation)
                        };
                        success = false;
                        _ctx.prev = 3;
                        _ctx.next = 6;
                        return _graphql_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* ["default"].mutate */ .Z.mutate({
                            mutation: (0,_apollo_client__WEBPACK_IMPORTED_MODULE_9__/* .gql */ .Ps)(gqlSaveMutation),
                            variables: variables
                        });
                    case 6:
                        result = _ctx.sent;
                        success = result.data[_this.graphQlSaveTranslationAlias].success;
                        if (success) {
                            graphQlObject = result.data[_this.graphQlSaveTranslationAlias].object;
                            entity.copyFromGraphQL(graphQlObject);
                        } else {
                            console.log("Save entity translation mutation not successful: " + _this.graphQlSaveTranslationAlias);
                            console.log(gqlSaveMutation);
                            console.log(JSON.stringify(variables));
                        }
                        _ctx.next = 18;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](3);
                        console.log("Error: save entity translation mutation failed: " + _this.graphQlSaveTranslationAlias);
                        console.log(_ctx.t0.message);
                        console.log(gqlSaveMutation);
                        console.log(JSON.stringify(variables));
                        throw "Save entity translation mutation failed: " + _this.graphQlSaveTranslationAlias;
                    case 18:
                        return _ctx.abrupt("return", success);
                    case 19:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    3,
                    11
                ]
            ]);
        }))();
    };
    /**
     * Create the GraphQL save translation mutation for the BusinessEntityWithTranslation.
     * https://graphql.org/learn/queries/#mutations
     * 
     * @returns The GraphQL mutation string.
     */ _proto.createGraphQlSaveTranslationMutation = function createGraphQlSaveTranslationMutation() {
        var saveMutation = "";
        saveMutation += "mutation Save".concat(this.name, "Translation($id: Int!, $input: ").concat(this.graphQlTranslationInputAlias, "!) {") + "\n";
        saveMutation += "".concat(this.graphQlSaveTranslationAlias, "(id: $id, input: $input) {") + "\n";
        saveMutation += "success" + "\n";
        saveMutation += "object {" + "\n";
        saveMutation += "...".concat(this.name, "DetailsFragment") + "\n";
        saveMutation += "}" + "\n";
        saveMutation += "}" + "\n";
        saveMutation += "}" + "\n";
        saveMutation += this.buildEntityDetailsFragment();
        return saveMutation;
    };
    /**
     * Create an input object for the GraphQL save translation mutation.
     * https://graphql.org/learn/schema/#input-types
     * 
     * @param language The translation language.
     * @param translation The object that holds the translation texts.
     * @returns The GraphQL input object.
     */ _proto.createTranslationInputObject = function createTranslationInputObject(language, translation) {
        var inputObject = {};
        inputObject.id = translation.id;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.translationFields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var translationField = _step.value;
                if (translationField.name == "language") {
                    inputObject[translationField.name] = language; // language is always set
                } else if (translationField.isInput) {
                    // Check required field
                    if (translation[translationField.name] === undefined && translationField.isRequiredInput) {
                        throw new Error("Required translation input field ".concat(translationField.name, " on ").concat(this.name, " has no value set."));
                    }
                    var _inputName;
                    // The input field name (the input field name can differ from the actual field name. Eg: region -> regionId)
                    var inputFieldName = (_inputName = translationField.inputName) !== null && _inputName !== void 0 ? _inputName : translationField.name;
                    // The translation field value
                    inputObject[inputFieldName] = translation[inputFieldName];
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return inputObject;
    };
    return EntityWithTranslationManager;
}(_BusinessEntity__WEBPACK_IMPORTED_MODULE_2__/* .EntityManager */ .v2);
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (BusinessEntity)));


/***/ }),

/***/ 298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f5": function() { return /* binding */ imageInfoGraphQlDetails; }
/* harmony export */ });
/* unused harmony exports AppTrackerEvent, AppTrackerEventCategory */
var AppTrackerEvent;
(function(AppTrackerEvent) {})(AppTrackerEvent || (AppTrackerEvent = {}));
var AppTrackerEventCategory;
(function(AppTrackerEventCategory) {})(AppTrackerEventCategory || (AppTrackerEventCategory = {}));
/** The GraphQL query field details for a web image. */ var imageInfoGraphQlDetails = "url width height";


/***/ }),

/***/ 1163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(387)


/***/ }),

/***/ 9396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ })

}]);